import { useQuery, UseQueryResult } from 'react-query';
import api from '~/services/api';

const fetchNotificacoes = async () => {
  const { data } = await api.post('/central-de-notificacoes/notificacoes', {
    tipo_notificacao_filtro: 0,
    des_pesquisa: '',
    orderBy: ['dta_cadastro desc'],
    start: 0,
    tipo_notificacao_prioridade: -1,
    limit: 5,
  });
  if (!data.success) throw new Error('Erro ao buscar notificações');
  return data.data;
};

export const useNotificacoes = (enabled: boolean): UseQueryResult<any, Error> =>
  useQuery('notificacoes', fetchNotificacoes, {
    enabled,
    staleTime: 1000 * 60 * 60, // 1h
    cacheTime: 1000 * 60 * 60, // 1h
    refetchOnWindowFocus: false,
    retry: 1,
  });
